import { useQuery } from '@apollo/client';
import READ_LAST_RECURRING_PAYMENT from 'graphql/queries/readLastRecurringPayment';
import { SalesOrderReceipt } from 'screens/permit/SalesOrderReceiptClass';
import {
  Query,
  QueryReadLastRecurringPaymentArgs,
} from 'types/generatedSchemaTypes';
import { isRecurringPaymentRetryWindowExpired } from 'utils/permitUtils';

// True once the PMC's authoriseFailure window for the failed recurring payment
// has passed, i.e. the order will be terminated and retrying no longer helps.
const useIsRecurringPaymentRetryWindowExpired = (
  salesOrderReceipt: SalesOrderReceipt
): boolean => {
  const {
    uid,
    isFailedRecurringPaymentForSalesOrder,
    authoriseFailureLimitMinutes,
    countryCode,
  } = salesOrderReceipt;

  const { data } = useQuery<Query, QueryReadLastRecurringPaymentArgs>(
    READ_LAST_RECURRING_PAYMENT,
    {
      variables: { input: { salesOrderUid: uid } },
      fetchPolicy: 'cache-and-network',
      skip:
        !uid ||
        !isFailedRecurringPaymentForSalesOrder ||
        !authoriseFailureLimitMinutes,
    }
  );

  return (
    isFailedRecurringPaymentForSalesOrder &&
    isRecurringPaymentRetryWindowExpired({
      paymentPeriodStart: data?.readLastRecurringPayment?.validity?.validFrom,
      authoriseFailureMinutes: authoriseFailureLimitMinutes,
      countryCode,
    })
  );
};

export default useIsRecurringPaymentRetryWindowExpired;
